import { render, staticRenderFns } from "./CCMRecordInfo.vue?vue&type=template&id=9fd07e5a"
import script from "./CCMRecordInfo.vue?vue&type=script&lang=js"
export * from "./CCMRecordInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports